import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from './search.service';

@Component({
  selector: 'app-service-directory',
  templateUrl: './services-directory.component.html',
  styleUrls: ['./services-directory.component.scss']
})
export class ServiceDirectoryComponent implements OnInit {
  pt: string = 'pt-100';
  pb: string = 'pb-70'; 
  ptb: string = 'ptb-100'; 
  section: string = 'services-directory'; 
  title: string = 'Si no ha encontrado lo que buscaba, Contáctanos.'; 
  results: any[] = [];
  query:string = '';
  search:string = '';

  constructor( private route: ActivatedRoute, private searchService: SearchService) { }

  ngOnInit(): void {
    
    this.query = history.state.data;
    this.search=this.query;
    this.onSearch(this.query);
   
  }
  searchServices(){
    this.query=this.search;
    this.onSearch(this.search);
  }

  onSearch(query:string) {
    this.results = this.searchService.search(query);
  }
}
